import { Injectable } from '@angular/core';

@Injectable()
export class JWTService {
  private jwt:string;
  public static readonly JWT_KEY:string = "dintchg"
  public static readonly JWT_EXPIRED_MSG_CODE = "jwt_expired";

  constructor() { 
    console.log("loading JwtService")
  }

  setToken(jwt: string) {
    if (jwt && jwt.length > 0) {
      this.jwt = jwt;
    } else {
      console.log("setToken(): jwt not set: bad token ☹️",jwt);
    }
  }

  getToken(): string {
    if (!this.jwt) {
      console.log("getToken(): jwt not exist! ☹️");
    }

    return this.jwt;
  }

  clearJwt() {
    this.jwt = null;
    console.log("jwt cleared!");
  }

  
}



// WEBPACK FOOTER //
// ./src/app/services/jwt.service.ts